import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Bell — gently swings from its crown (8,3) whenever active, with a
 *  matching clapper countermotion and a one-time chime arc on each swing.
 *  CSS hover shake still applies for the inactive state (see icons.css). */
export function IcnBell(props: AnimatedIconProps): ReactNode {
  const { active = false, ...rest } = props;
  const animate = useDecorativeIconMotion(active);
  return (
    <Svg {...rest} iconName="bell" data-on={active ? 'true' : 'false'}>
      <g style={{ transformOrigin: '8px 3px' }}>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0;12;-10;6;-4;2;0"
            keyTimes="0;0.08;0.22;0.42;0.62;0.82;1"
            dur="1.8s"
            repeatCount="indefinite"
          />
        )}
        <path d="M3.5 11h9l-1-1.5V7a3.5 3.5 0 0 0-7 0v2.5L3.5 11z" />
        <path d="M6.5 13a1.5 1.5 0 0 0 3 0">
          {animate && (
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="0 8 11;-8 8 11;5 8 11;-3 8 11;0 8 11"
              keyTimes="0;0.18;0.42;0.7;1"
              dur="1.8s"
              repeatCount="indefinite"
            />
          )}
        </path>
      </g>
      {animate && (
        <g opacity="0.45" stroke="currentColor" fill="none" strokeLinecap="round">
          <path d="M1.5 6.5a3 3 0 0 1 1-2">
            <animate
              attributeName="opacity"
              values="0;0.55;0"
              keyTimes="0;0.4;1"
              dur="1.8s"
              repeatCount="indefinite"
            />
          </path>
          <path d="M14.5 6.5a3 3 0 0 0-1-2">
            <animate
              attributeName="opacity"
              values="0;0.55;0"
              keyTimes="0;0.4;1"
              dur="1.8s"
              begin="0.22s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      )}
    </Svg>
  );
}
